'use client';

import { useEffect, useState } from 'react';
import { getClientSdk } from '@/ui-components/organisms/AccountSnapshot/clientSdk';

export type NavigationAuthStatus = 'loading' | 'anonymous' | 'authenticated';

export function useNavigationAuthStatus(): NavigationAuthStatus {
    const [status, setStatus] = useState<NavigationAuthStatus>('loading');

    useEffect(() => {
        let cancelled = false;
        let unsubscribe: (() => void) | undefined;

        const updateStatus = (sessionType?: string) => {
            if (!cancelled) {
                setStatus(sessionType === 'authenticated' ? 'authenticated' : 'anonymous');
            }
        };

        const observeSession = async () => {
            const clientSdk = await getClientSdk();

            if (!clientSdk || cancelled) {
                updateStatus();
                return;
            }

            unsubscribe = clientSdk.user.sessionEvents.subscribe((event) => {
                updateStatus(event.sessionType);
            });

            updateStatus(clientSdk.user.getUserInfo().session?.sessionType);
        };

        void observeSession().catch(() => updateStatus());

        return () => {
            cancelled = true;
            unsubscribe?.();
        };
    }, []);

    return status;
}
